// extracted by mini-css-extract-plugin
export default {"loading":"feedbackList_loading__-t1nK","pcWrap":"feedbackList_pcWrap__AYp6h"};